import React from 'react';
import { ResearchIntro } from '../components/research/ResearchIntro';
import { ResearchSkp } from '../components/research/ResearchSkp';
import { ResearchPriorities } from '../components/research/ResearchPriorities';
import { CognarchicFoundation } from '../components/research/CognarchicFoundation';
import { OperationalSystems } from '../components/research/OperationalSystems';
import { ResearchTesting } from '../components/research/ResearchTesting';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
export function ResearchPage() {
  return <>
      <ResearchIntro data-id="element-3281" data-mp="35gpm1lw4y11o" />
      <ResearchSkp data-id="element-3282" data-mp="35g7jy8mskslu" />
      <ResearchPriorities data-id="element-3283" data-mp="35hsfo1kuehla" />
      <RelatedInitiative name="Cognocracy" status="Concept Proposal" body="A proposed civic governance project that draws on this research, including the NCJI assessment model and its open questions." href="/projects/cognocracy" data-id="element-3284" data-mp="35j3hvwyn3haa" />
      <CognarchicFoundation data-id="element-3285" data-mp="yruj41houyce" />
      <OperationalSystems data-id="element-3286" data-mp="yogjv24bn596" />
      <ResearchTesting data-id="element-3287" data-mp="6xjum3ich1zq" />
    </>;
}